import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSPBDCertificationList,
  fetchSpecialityList,
  addProviderSpeciality,
  deleteProviderSpeciality,
  updateProviderSpeciality,
  fetchSpecialityLanguageSuggestions,
  fetchSpecialtyOptions,
  deleteProviderSPBDCert,
  fetchDeleteSpeciality,
  fetchSpecialtyBoardOptions,
  fetchSpecialtyCertifications,
  addProviderSPBDCertifications
} from "./ProviderSpecialityActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerSpeciality = createSlice({
  name: "providerSpeciality",
  initialState: {
    isSpecialityLoading: false,
    isAddingSpeciality: false,
    isDeletingSpeciality: false,
    isUpdatingSpeciality: false,
    isSpecialtyOptionsLoading: false,
    specialityData: [],
    specialityError: null,
    specialityErrorMsg: "",
    addSpecialityError: null,
    addSpecialityErrorMsg: "",
    deleteSpecialityError: null,
    deleteSpecialityErrorMsg: "",
    updateSpecialityError: null,
    updateSpecialityErrorMsg: "",
    specialtyOptions: [],
    specialtyOptionsError: null,
    specialtyOptionsErrorMsg: "",
    directDeleteLoading: false,
    directDeleteError: null,
    directDeleteErrorMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialityList.pending, (state) => {
        state.isSpecialityLoading = true;
        state.specialityError = null;
        state.specialityErrorMsg = "";
      })
      .addCase(fetchSpecialityList.fulfilled, (state, action) => {
        state.isSpecialityLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.specialityError = true;
          state.specialityErrorMsg = getApiErrorMessage(action.payload.status);
          state.specialityData = [];
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          state.specialityData = action.payload;
          state.specialityError = false;
        } else {
          state.specialityData = action.payload;
          state.specialityError = false;
        }
      })
      .addCase(fetchSpecialityList.rejected, (state, action) => {
        state.isSpecialityLoading = false;
        state.specialityError = true;
        state.specialityErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
        state.specialityData = [];
      })
      .addCase(fetchSpecialtyOptions.pending, (state) => {
        state.isSpecialtyOptionsLoading = true;
        state.specialtyOptionsError = null;
        state.specialtyOptionsErrorMsg = "";
      })
      .addCase(fetchSpecialtyOptions.fulfilled, (state, action) => {
        state.isSpecialtyOptionsLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.specialtyOptionsError = true;
          state.specialtyOptionsErrorMsg = getApiErrorMessage(action.payload.status);
          state.specialtyOptions = [];
        } else if (action.payload?.data?.specialtyResponseDTO) {
          state.specialtyOptions = action.payload.data.specialtyResponseDTO;
          state.specialtyOptionsError = false;
        } else {
          state.specialtyOptionsError = true;
          state.specialtyOptionsErrorMsg = getApiErrorMessage(500); 
          state.specialtyOptions = [];
        }
      })
      .addCase(fetchSpecialtyOptions.rejected, (state, action) => {
        state.isSpecialtyOptionsLoading = false;
        state.specialtyOptionsError = true;
        state.specialtyOptionsErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
        state.specialtyOptions = [];
      })
      .addCase(addProviderSpeciality.pending, (state) => {
        state.isAddingSpeciality = true;
        state.addSpecialityError = null;
        state.addSpecialityErrorMsg = "";
      })
      .addCase(addProviderSpeciality.fulfilled, (state, action) => {
        state.isAddingSpeciality = false;
        
        if (action.payload && action.payload.success === false) {
          state.addSpecialityError = true;
          state.addSpecialityErrorMsg = getApiErrorMessage(action.payload.status);
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          state.specialityData = action.payload;
          state.addSpecialityError = false;
        } else {
          state.addSpecialityError = false;
        }
      })
      .addCase(addProviderSpeciality.rejected, (state, action) => {
        state.isAddingSpeciality = false;
        state.addSpecialityError = true;
        state.addSpecialityErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
      })
      .addCase(deleteProviderSpeciality.pending, (state) => {
        state.isDeletingSpeciality = true;
        state.deleteSpecialityError = null;
        state.deleteSpecialityErrorMsg = "";
      })
      .addCase(deleteProviderSpeciality.fulfilled, (state, action) => {
        state.isDeletingSpeciality = false;
        
        if (action.payload && action.payload.success === false) {
          state.deleteSpecialityError = true;
          state.deleteSpecialityErrorMsg = getApiErrorMessage(action.payload.status);
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
         
          if (action.payload.data) {
            state.specialityData = action.payload.data;
          }
          state.deleteSpecialityError = false;
        } else {
          state.deleteSpecialityError = false;
        }
      })
      .addCase(deleteProviderSpeciality.rejected, (state, action) => {
        state.isDeletingSpeciality = false;
        state.deleteSpecialityError = true;
        state.deleteSpecialityErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
      })
      .addCase(updateProviderSpeciality.pending, (state) => {
        state.isUpdatingSpeciality = true;
        state.updateSpecialityError = null;
        state.updateSpecialityErrorMsg = "";
      })
      .addCase(updateProviderSpeciality.fulfilled, (state, action) => {
        state.isUpdatingSpeciality = false;
        
        if (action.payload && action.payload.success === false) {
          state.updateSpecialityError = true;
          state.updateSpecialityErrorMsg = getApiErrorMessage(action.payload.status);
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          if (action.payload.data) {
            state.specialityData = action.payload.data;
          }
          state.updateSpecialityError = false;
        } else {
          state.updateSpecialityError = false;
        }
      })
      .addCase(updateProviderSpeciality.rejected, (state, action) => {
        state.isUpdatingSpeciality = false;
        state.updateSpecialityError = true;
        state.updateSpecialityErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
      })
      .addCase(fetchDeleteSpeciality.pending, (state) => {
        state.directDeleteLoading = true;
        state.directDeleteError = null;
        state.directDeleteErrorMsg = "";
      })
      .addCase(fetchDeleteSpeciality.fulfilled, (state, action) => {
        state.directDeleteLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.directDeleteError = true;
          state.directDeleteErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.directDeleteError = false;
        }
      })
      .addCase(fetchDeleteSpeciality.rejected, (state, action) => {
        state.directDeleteLoading = false;
        state.directDeleteError = true;
        state.directDeleteErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
      });
  },
});

const providerSPBDCertificate = createSlice({
  name: "providerSPBDCertificate",
  initialState: {
    isSPBDLoading: false,
    isAddingSPBD: false,
    spbdData: [],
    spbdError: null,
    spbdErrorMsg: "",
    spbdAddError: "",
    spbdDeleteError: "",
    spbdDeleteLoading: false,
  },
  reducers: {
    addProviderSPBDCert: (state, action) => {
      state.spbdData = action.payload;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSPBDCertificationList.pending, (state) => {
        state.isSPBDLoading = true;
        state.spbdError = null;
        state.spbdErrorMsg = "";
      })
      .addCase(fetchSPBDCertificationList.fulfilled, (state, action) => {
        state.isSPBDLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.spbdError = true;
          state.spbdErrorMsg = getApiErrorMessage(action.payload.status);
          state.spbdData = [];
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome) {
          
          if (action.payload.metadata?.outcome.status === 404) {
            const additionalDetails = action.payload.metadata?.outcome.additionalDetails;
            if (additionalDetails && additionalDetails.length > 0 && 
                additionalDetails[0].additionalInfo && 
                additionalDetails[0].additionalInfo.includes("No data found")) {
              
              state.spbdData = [];
              state.spbdError = false;
            } else {
              state.spbdError = true;
              state.spbdErrorMsg = getApiErrorMessage(404);
              state.spbdData = [];
            }
          } else if (action.payload.metadata?.outcome.status === 200) {
            if (action.payload.data && 
                action.payload.data.providerSpecialtyCertificationResponseDTO) {
              state.spbdData = action.payload.data.providerSpecialtyCertificationResponseDTO;
              state.spbdError = false;
            } else if (action.payload.data && 
                      action.payload.data.data && 
                      action.payload.data.data.providerSpecialtyCertificationResponseDTO) {
              state.spbdData = action.payload.data.data.providerSpecialtyCertificationResponseDTO;
              state.spbdError = false;
            } else {
              state.spbdData = [];
              state.spbdError = false;
            }
          } else {
            state.spbdError = true;
            state.spbdErrorMsg = getApiErrorMessage(action.payload.metadata?.outcome.status || 500);
            state.spbdData = [];
          }
        } else if (Array.isArray(action.payload)) {
          state.spbdData = action.payload;
          state.spbdError = false;
        } else {
          state.spbdData = [];
          state.spbdError = true;
          state.spbdErrorMsg = getApiErrorMessage(500);
        }
      })
      .addCase(fetchSPBDCertificationList.rejected, (state, action) => {
        state.isSPBDLoading = false;
        state.spbdError = true;
        state.spbdErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
        state.spbdData = [];
      })
      .addCase(addProviderSPBDCertifications.pending, (state) => {
        state.isAddingSPBD = true;
        state.spbdAddError = "";
      })
      .addCase(addProviderSPBDCertifications.fulfilled, (state, action) => {
        state.isAddingSPBD = false;
        
        if (action.payload && action.payload.success === false) {
          state.spbdAddError = getApiErrorMessage(action.payload.status);
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          
          if (action.payload.data && 
              action.payload.data.providerSpecialtyCertificationResponseDTO) {
            state.spbdData = action.payload.data.providerSpecialtyCertificationResponseDTO;
          }
          state.spbdAddError = "";
        } else {
          state.spbdAddError = "";
        }
      })
      .addCase(addProviderSPBDCertifications.rejected, (state, action) => {
        state.isAddingSPBD = false;
        state.spbdAddError = action.error.message || getApiErrorMessage(action.error?.status || 500);
      })
      .addCase(deleteProviderSPBDCert.pending, (state) => {
        state.spbdDeleteLoading = true;
        state.spbdDeleteError = "";
      })
      .addCase(deleteProviderSPBDCert.fulfilled, (state, action) => {
        state.spbdDeleteLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.spbdDeleteError = getApiErrorMessage(action.payload.status);
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          
          if (action.payload.data && 
              action.payload.data.providerSpecialtyCertificationResponseDTO) {
            state.spbdData = action.payload.data.providerSpecialtyCertificationResponseDTO;
          }
          state.spbdDeleteError = "";
        } else {
          state.spbdDeleteError = "";
        }
      })
      .addCase(deleteProviderSPBDCert.rejected, (state, action) => {
        state.spbdDeleteLoading = false;
        state.spbdDeleteError = action.error.message || getApiErrorMessage(action.error?.status || 500);
      });
  },
});

const specialtyBoardSlice = createSlice({
  name: "specialtyBoard",
  initialState: {
    isSpecialtyBoardLoading: false,
    specialtyBoardData: null,
    specialtyBoardError: null,
    specialtyBoardErrorMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialtyBoardOptions.pending, (state) => {
        state.isSpecialtyBoardLoading = true;
        state.specialtyBoardError = null;
        state.specialtyBoardErrorMsg = "";
      })
      .addCase(fetchSpecialtyBoardOptions.fulfilled, (state, action) => {
        state.isSpecialtyBoardLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.specialtyBoardError = true;
          state.specialtyBoardErrorMsg = getApiErrorMessage(action.payload.status);
          state.specialtyBoardData = null;
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          state.specialtyBoardData = action.payload.data?.specialtyBoardRawSearchResponseDTO || null;
          state.specialtyBoardError = false;
        } else {
          state.specialtyBoardError = true;
          state.specialtyBoardErrorMsg = getApiErrorMessage(500);
          state.specialtyBoardData = null;
        }
      })
      .addCase(fetchSpecialtyBoardOptions.rejected, (state, action) => {
        state.isSpecialtyBoardLoading = false;
        state.specialtyBoardError = true;
        state.specialtyBoardErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
        state.specialtyBoardData = null;
      });
  },
});

const specialtyCertificationSlice = createSlice({
  name: "specialtyCertification",
  initialState: {
    isSpecialtyCertLoading: false,
    specialtyCertData: [],
    specialtyCertError: null,
    specialtyCertErrorMsg: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialtyCertifications.pending, (state) => {
        state.isSpecialtyCertLoading = true;
        state.specialtyCertError = null;
        state.specialtyCertErrorMsg = "";
      })
      .addCase(fetchSpecialtyCertifications.fulfilled, (state, action) => {
        state.isSpecialtyCertLoading = false;
        
        if (action.payload && action.payload.success === false) {
          state.specialtyCertError = true;
          state.specialtyCertErrorMsg = getApiErrorMessage(action.payload.status);
          state.specialtyCertData = [];
        } else if (action.payload && action.payload.metadata && 
                  action.payload.metadata?.outcome && 
                  action.payload.metadata?.outcome.status === 200) {
          state.specialtyCertData = action.payload.data?.specialtyCertRawSearchResponseDTO || [];
          state.specialtyCertError = false;
        } else {
          state.specialtyCertError = true;
          state.specialtyCertErrorMsg = getApiErrorMessage(500);
          state.specialtyCertData = [];
        }
      })
      .addCase(fetchSpecialtyCertifications.rejected, (state, action) => {
        state.isSpecialtyCertLoading = false;
        state.specialtyCertError = true;
        state.specialtyCertErrorMsg = action.error.message || getApiErrorMessage(action.error?.status || 500);
        state.specialtyCertData = [];
      });
  },
});

const providerSpecialityLanguageSuggestions = createSlice({
  name: "langSuggestion",
  initialState: {
    isSuggesrionLoading: false,
    suggestionData: [],
    suggestionError: null,
    langSuggestionErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSpecialityLanguageSuggestions.pending, (state) => {
        state.isSuggesrionLoading = true;
        state.suggestionError = null;
      })
      .addCase(fetchSpecialityLanguageSuggestions.fulfilled, (state, action) => {
        state.isSuggesrionLoading = false;
        
        if (action.payload && action.payload.success) {
          state.suggestionError = false;
         
          const items = action.payload?.data?.data?.institutionResponseDTO?.items || 
                        action.payload?.data?.data?.languageResponseDTO?.items;
          
          if (items && Array.isArray(items)) {
            state.suggestionData = items.map((item, index) => ({
              name: item.name || item.institutionName || "",
              displayId: item.displayId || index.toString()
            }));
          } else {
            state.suggestionData = [];
          }
        } else {
          state.suggestionData = [];
          state.suggestionError = false;
        }
      })
      .addCase(fetchSpecialityLanguageSuggestions.rejected, (state, action) => {
        state.isSuggesrionLoading = false;
        state.suggestionError = action.error.message;
        state.suggestionData = [];
      });
  },
});

export const { addProviderSPBDCert } = providerSPBDCertificate.actions;
export const providerSpecilityReducer = providerSpeciality.reducer;
export const providerSPBDCertReducer = providerSPBDCertificate.reducer;
export const SpecialitylanguageSuggestionReducer = providerSpecialityLanguageSuggestions.reducer;
export const specialtyBoardReducer = specialtyBoardSlice.reducer;
export const specialtyCertificationReducer = specialtyCertificationSlice.reducer;
